import { Component, OnInit } from '@angular/core';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';
import { AvataresService } from 'src/app/shared/service/avatares/avatares.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { CommonService } from 'src/app/shared/service/common/common.service';
import { CountryCmbDto } from 'src/app/shared/dto/country.dto';
import { CityDto, StateDto } from 'src/app/shared/dto/city.dto';
import { ProfileService } from '../../../profile/services/profile.service';
import { ProfileDto } from 'src/app/components/profile/panel-start/dto/profile';

@Component({
  selector: 'app-home-profile',
  templateUrl: './home-profile.component.html',
  styleUrl: './home-profile.component.css',
})
export class HomeProfileComponent implements OnInit {
  selectedAvatar!: string;
  isModalOpen: boolean = false;
  profileForm!: FormGroup;
  profile!: ProfileDto;

  avatars: string[] = [];
  countries: CountryCmbDto[] = [];
  states: StateDto[] = [];
  cities: CityDto[] = [];

  constructor(
    private analitycs: AnalitycsService,
    private avataresService: AvataresService,
    private fb: FormBuilder,
    private commonService: CommonService,
    private profileService: ProfileService,
  ) {
    // Inicializar el formulario vacío
    // Patrón de validación para contraseña
    const passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/;

    this.profileForm = this.fb.group(
      {
        name: ['', Validators.required],
        lastname: ['', Validators.required],
        country: ['', Validators.required],
        department: ['', Validators.required],
        city: ['', Validators.required],
        phone: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
        password: ['', [Validators.required, Validators.pattern(passwordPattern)]],
        confirmPassword: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
      },
      { validators: this.passwordsMatchValidator },
    );
  }

  async ngOnInit() {
    this.analitycs.logEvent('acceso_inicial_editar_perfil', {
      pantalla: 'edit-profile',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    this.getInfo();
    this.selectedAvatar = localStorage.getItem('selectedAvatar') ?? 'assets/images/juan1.png';

    const avatars: any = await this.avataresService.getAvatares();
    this.avatars = avatars.map((x: any) => x.img_avatar) ?? [];

    // Cargar países
    await this.getAvailableCountriesToCmb();
  }

  async getAvailableCountriesToCmb() {
    this.countries = await this.commonService.getAvailableCountriesToCmb();
  }

  async onCountryChange(event: any) {
    const selectedCountryCode = event.target.value;
    this.states = await this.commonService.getAvailableStatesByCountryCode(selectedCountryCode);
    this.profileForm.get('department')?.enable();
    this.profileForm.get('department')?.setValue('');
    this.cities = [];
  }

  async onDepartmentChange(event: any) {
    const selectedStateCode = event.target.value;
    this.cities = await this.commonService.getAvailableCityByStateCountryCode(this.profileForm.get('country')?.value, selectedStateCode);
    this.profileForm.get('city')?.enable();
  }

  openAvatarModal() {
    this.analitycs.logEvent('abrir_modal_avatar', {
      pantalla: 'edit-profile',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });

    this.isModalOpen = true;
  }
  async getInfo() {
    const result = await this.profileService.getInfo();
    this.profile = result;

    // Actualizar los valores del formulario con los datos del perfil
    if (this.profile) {
      this.profileForm.patchValue({
        name: this.profile.name?.first_name || '',
        lastname: this.profile.name?.last_name || '',
        email: this.profile.email || '',
        phone: this.profile.phone?.number || '',
        country: this.profile.country?.code || '',
        department: this.profile.department?.code || '',
        city: this.profile.city?.code || '',
      });

      // Si hay un país seleccionado, cargar los estados
      if (this.profile.country?.code) {
        this.states = await this.commonService.getAvailableStatesByCountryCode(this.profile.country.code);
        this.profileForm.get('department')?.enable();
      }

      // Si hay un departamento seleccionado, cargar las ciudades
      if (this.profile.department?.code) {
        this.cities = await this.commonService.getAvailableCityByStateCountryCode(this.profile.country?.code || '', this.profile.department.code);
        this.profileForm.get('city')?.enable();
      }
    }
  }

  closeAvatarModal() {
    this.analitycs.logEvent('cerrar_modal_avatar', {
      pantalla: 'edit-profile',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });

    this.isModalOpen = false;
    // window.location.reload();
  }

  selectAvatar(avatar: string) {
    this.analitycs.logEvent('seleccionar_avatar', {
      pantalla: 'edit-profile',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });

    this.selectedAvatar = avatar;
    this.avataresService.updateSelectedAvatar(avatar);
  }

  async submitForm() {
    // console.log('this.profileForm.valid', this.profileForm.value);
    if (this.profileForm.valid) {
      const selectedCountry = this.countries.find((c) => c.cca2 === this.profileForm.get('country')?.value);
      const selectedState = this.states.find((s) => s.state_code === this.profileForm.get('department')?.value);
      const selectedCity = this.cities.find((c) => c.city_code === this.profileForm.get('city')?.value);

      const profileData = {
        name: this.profileForm.get('name')?.value,
        lastName: this.profileForm.get('lastname')?.value,
        country_code: selectedCountry?.cca2 || '',
        country: selectedCountry?.name.nativeName.es.common || '',
        state_code: selectedState?.state_code || '',
        state: selectedState?.state_name || '',
        city_code: selectedCity?.city_code || '',
        city: selectedCity?.city_name || '',
        phone: {
          code: selectedCountry?.CODIGO_TEL_PAIS || '+57',
          number: this.profileForm.get('phone')?.value,
        },
        email: this.profileForm.get('email')?.value,
        password: this.profileForm.get('password')?.value,
      };

      try {
        const result = await this.profileService.updateProfile(profileData);
        if (result.code.code === 'PTZ0000') {
          Swal.fire({
            toast: true,
            icon: 'success',
            title: 'Perfil actualizado',
            text: 'Tu perfil se ha actualizado correctamente.',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            position: 'top',
          });
        } else {
          Swal.fire({
            toast: true,
            icon: 'error',
            title: 'Error',
            text: typeof result.code.message === 'object' ? result.code.message.es : result.code.message || 'Error al actualizar el perfil',
            showConfirmButton: true,
          });
        }
      } catch (error) {
        console.error('Error al actualizar el perfil:', error);
        Swal.fire({
          toast: true,
          icon: 'error',
          title: 'Error',
          text: 'No se pudo actualizar el perfil. Por favor, intenta nuevamente.',
          showConfirmButton: true,
        });
      }
    } else {
      //   Swal.fire({
      //     toast: true,
      //     icon: 'warning',
      //     title: '',
      //     text: '',
      //     showConfirmButton: false,
      //     timer: 3000,
      //     timerProgressBar: true,
      //     position: 'top',
      //   });
    }
  }
  passwordsMatchValidator(form: AbstractControl): null | object {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    if (password !== confirmPassword) {
      form.get('confirmPassword')?.setErrors({ mismatch: true });
      return { mismatch: true };
    } else {
      return null;
    }
  }
}
